<template>
  <div class="ranking" v-if="!loading && $store.state.auth.user && statistics">
    <Modal
      ref="changeNameModal"
      title="ニックネームを変更"
      :bodyHeight="'330px'"
      :footerHeight="'100px'"
      :visibleNeverShowCheckbox="false"
      @agreeButtonClicked="changeName"
      titleIcon="el-icon-user"
    >
      <div style="flex-direction: column; width: 400px">
        <h3>ランキング用のニックネームを入力してください</h3>
        <p style="color: #888">※このニックネームは他のユーザーへ公開されます。</p>
        <el-input v-model="name"></el-input>
        <div class="error">{{ nameError }}</div>
      </div>
    </Modal>

    <div class="stats-container">
      <div class="stats">
        <!-- <div
          style="display:flex; flex-direction: row; justify-content: space-between; align-items:center"
        >-->
        <!-- <div class="last-update">
            最終更新日時:
            {{ fbDateToString(statistics.lastUpdate.seconds * 1000) }}
        </div>-->
        <!-- <button class="button white" @click="load" :class="{ disabled: refreshDisabled }">
            更新
            <i class="el-icon-refresh" />
        </button>-->
        <!-- </div> -->
        <h3>
          <i class="el-icon-user-solid" />あなたのハイスコア情報
        </h3>
        <div
          class="item"
          :class="{ blur: !dataFound }"
          @click="toRankingTab()"
          style="cursor: pointer"
        >
          <div class="title">順位</div>
          <div class="details" :class="{'calculating': Number.isNaN(parseInt(myRanking.index))}">
            <div class="body">{{ Number.isNaN(parseInt(myRanking.index)) ? '計算中' : myRanking.index + 1 + '位' }}</div>
            <div class="detail">
              <span
                v-if="myRanking.index / statistics.total > 0.5"
              >下位{{100 - Math.round(( myRanking.index / statistics.total)*100)}}%</span>
              <span
                v-if="myRanking.index / statistics.total <= 0.5"
              >上位{{(Math.round(( myRanking.index / statistics.total)*100))}}%</span>
            </div>
          </div>
        </div>
        <div class="item" :class="{ blur: !dataFound }">
          <div class="title">ハイスコア</div>
          <div class="details">
            <div class="body">{{ myRanking.score }}点</div>
            <div class="detail">平均: {{ Math.round(average * 100) / 100 }}点</div>
          </div>
        </div>
        <div class="item" :class="{ blur: !dataFound }">
          <div class="title">偏差値</div>
          <div class="details">
            <div class="body">{{ Math.round(ss * 100) / 100 }}</div>
            <div class="detail">{{ fbDateToString(myRanking.createdAt.seconds * 1000) }}受験</div>
          </div>
        </div>
        <div class="nodata" v-if="!dataFound">
          <div class="title">ここに受験したテストに関する統計情報が表示されます</div>
          <div class="body">現在表示可能なデータがありません。スコアの反映には時間がかかる場合があります。</div>
        </div>
      </div>
      <Chart style="width: 100%" />
    </div>

    <!-- <table v-if="dataFound">
      <thead>
        <tr>
          <th>順位</th>
          <th>ニックネーム</th>
          <th>ハイスコア</th>
          <th>受験日時</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="rank in othersRanking"
          :key="rank.index"
          :class="{ 'user-score': rank.uid === $store.state.auth.user.uid }"
        >
          <td>{{ rank.index + 1 }}</td>
          <td>{{ rank.name }}</td>
          <td>
            <span class="score">{{ rank.score }}</span>
          </td>
          <td>
            <template v-if="rank.createdAt">
              {{
              fbDateToString(rank.createdAt.seconds * 1000)
              }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>

    <button class="button change-name" @click="showCangeNameModal">
      <i class="el-icon-user" />
      ランキング用の表示名を変更
    </button>

    <h3>
      <i class="el-icon-star-on" />トップ10位受験者のランキング
    </h3>
    <table>
      <thead>
        <tr>
          <th>順位</th>
          <th>ニックネーム</th>
          <th>ハイスコア</th>
          <th>受験日時</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(rank, index) in topTen"
          :key="rank.index"
          :class="{ 'user-score': rank.uid === $store.state.auth.user.uid }"
        >
          <td class="rank" :class="{ 'rank-top-three': index < 3 }">{{ rank.index + 1 }}</td>
          <td>{{ rank.name }}</td>
          <td>
            <span class="score" :class="{ 'top-three': index < 3 }">
              {{
              rank.score
              }}
            </span>
          </td>
          <td>
            <template v-if="rank.createdAt">
              {{
              fbDateToString(rank.createdAt.seconds * 1000)
              }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
    <h3>
      <i class="el-icon-s-data" />テスト受験者のハイスコア分布
    </h3>
    <chartist
      ratio="ct-major-second"
      type="Bar"
      class="chart"
      :data="chartData"
      :options="{
        distributeSeries: true,
        height: 300,
      }"
    ></chartist>-->
    <!-- <h3>
      <i class="el-icon-s-marketing" />その他の統計情報
    </h3>
    <ul>
      <li>標準偏差: {{ sd }}</li>
      <li>平均値: {{ average }}</li>
      <li>標本数: {{ sampledNumber }}</li>
    </ul>-->
  </div>
</template>

<script>
import { db } from "@/plugins/firebase";
import Vue from "vue";
Vue.use(require("vue-chartist"));
import { fbDateToString } from "@/utils/functions";
import firebase from "firebase/app";

export default {
  components: {
    Modal: require("@/components/Modal").default,
    Chart: require("./Chart").default
  },
  methods: {
    toRankingTab() {
      this.$emit("to-ranking-tab");
    },
    fbDateToString,
    async load() {
      let self = this;

      this.refreshDisabled = true;
      setTimeout(() => {
        self.refreshDisabled = false;
      }, 5000);
      self.loading = true;
      self.$emit("load-start");
      try {
        const userRankingRef = await db
          .collection("Ranking")
          .doc(self.$store.state.auth.user.uid)
          .get();
        if (userRankingRef.exists) {
          self.$store.commit("setName", userRankingRef.data().name);
          if (userRankingRef.data().score) {
            self.dataFound = true;
            self.myRanking = userRankingRef.data();
            const index = userRankingRef.data().index;
            self.name = userRankingRef.data().name;
          }
        }

        const statisticsRef = await db
          .collection("Statistics")
          .doc("ranking")
          .get();
        self.statistics = statisticsRef.data();
        const { total, sum, sumResSq } = statisticsRef.data();
        this.sampledNumber = total;
        const average = sum / total;
        this.average = average;
        if (userRankingRef.exists) {
          const sd = Math.sqrt(sumResSq / (total - 1));
          this.sd = sd;
          const ss = (10 * (this.myRanking.score - average)) / sd + 50;
          this.ss = ss;
        }
      } catch (err) {
        console.log(err);
      } finally {
        self.loading = false;

        this.$emit("load-finished");
      }
    },
    showCangeNameModal() {
      this.$refs.changeNameModal.showModal();
    },
    changeName() {
      this.$emit("load-start");

      const changeNameFunc = firebase
        .functions()
        .httpsCallable("changeRankingName");
      try {
        changeNameFunc({ name: this.name }).then(() => {
          this.load();
          this.$notify({
            type: "success",
            title: "成功",
            message: "表示名の変更が完了しました。"
          });
        });
      } finally {
        this.$refs.changeNameModal.closeModal();
      }
    }
  },
  computed: {
    nameValid() {
      this.name.length < 16 && this.name > 2;
    },
    chartData() {
      if (this.statistics) {
        return {
          series: Object.values(this.statistics.distribution),
          labels: Object.keys(this.statistics.distribution).map(interval => {
            return String(parseInt(interval) * 100);
          })
        };
      }
    }
  },
  watch: {
    name(name) {
      console.log(name);
      if (name.length > 16) {
        this.nameError =
          "ニックネームが長すぎます。16文字以下で入力してください。";
      } else if (name.length < 3 && name.length !== 0) {
        this.nameError =
          "ニックネームが短かすぎます。3文字以上で入力してください。";
      } else {
        this.nameError = "";
      }
    }
  },
  data() {
    return {
      name: "",
      nameError: "",
      refreshDisabled: false,
      changeNameLoading: false,
      loading: true,
      myRanking: {
        index: 123,
        score: 1234,
        name: "DEFAULT_NAME",
        createdAt: new Date()
      },
      statistics: {
        lastUpdate: {
          seconds: 0
        }
      },
      ss: 60,
      dataFound: false,
      othersRanking: [],
      topTen: [],
      totalRanking: null,
      statistics: null,
      sd: 0,
      average: 0,
      sampledNumber: 0
    };
  },
  mounted() {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
.ranking {
  padding: 0 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  h3 {
    align-self: flex-start;
  }
}
h3 {
  margin: 10px 0;
  &:first-child {
    margin: 0 0 10px 0;
  }
  i {
    margin-right: 4px;
  }
}

.chart {
  max-height: 300px;
}

table {
  text-align: center;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #eee;
  width: 80%;
  margin: 10px 0 10px 0;
  font-weight: bold;
  .user-score {
    background-color: #f88;
    color: white;
  }

  td {
    border: none;
    padding: 4px 0;
    margin: 0;
  }
  thead {
    font-size: 0.9rem;
    font-weight: 800;
  }

  tbody {
    font-size: 0.92rem;
  }
}
.last-update {
  align-self: flex-end;
  color: #aaa;
  font-size: 0.8rem;
  font-weight: bold;
}

.stats {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  position: relative;
  margin: 0 20px 15px 20px;
  .nodata {
    position: absolute;
    user-select: none;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    background-color: rgba(255, 255, 255, 0.9);
    font-size: 0.9rem;
    text-align: center;
    padding: 20px 20px;
    width: 300px;
    height: 100px;
    z-index: 80;
    /* border-radius: 200px; */
    box-shadow: 3px 3px 14px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title {
      font-weight: bold;
      color: #f88;
    }
    .body {
      font-size: 0.8rem;
      margin-top: 5px;
    }
  }
  .item {
    width: 280px;
    height: 90px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #eee;
    box-sizing: border-box;
    padding: 10px 25px;
    margin: 3px 0;
    border-radius: 5px;
    &:hover {
      background-color: #f8f8f8;
    }

    .title {
      font-weight: bold;
      /* border-bottom: 1px solid #eee; */
      text-align: center;
      padding-bottom: 4px;
    }
    .details {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      .detail {
        font-size: 0.78rem;
        color: #888;
      }
      .body {
        font-size: 2rem;
        font-weight: 900;
      }
    }
  }
}

.change-name {
  align-self: center;
  margin: 20px 0 10px 0;
}

.blur {
  filter: blur(4px);
}

.rank {
  font-size: 1.13rem;
  font-weight: 900;
}

.rank-top-three {
  font-size: 1.35rem;
  color: #f88;
}

thead {
  border-bottom: 1px solid #eee;
}

.score {
  font-size: 1.13rem;
  font-weight: 900;
}
.top-three {
  font-size: 1.35rem;
  color: #f88;
}

th {
  font-weight: 900;
}

.stats-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.calculating {
  color: #888;
}
</style>
